import {
  getDocumentMeta,
  sharedHrefResolver,
} from 'remote-com-shared/domains/navigation/hrefResolver';
import { composeCurrentUrl } from 'remote-com-shared/utils/seo';

const basePath = process.env.NEXT_PUBLIC_BASE_PATH || '';

export const hrefResolver = sharedHrefResolver;

export function linkResolver(document) {
  const { type, uid } = getDocumentMeta(document);
  switch (type) {
    default:
      return hrefResolver(document).replace('[uid]', uid);
  }
}

export function absoluteLinkResolver(document) {
  return basePath + linkResolver(document);
}

// FIXED: using absoluteLinkResolver here would result in "remote.com/blog/blog/*"
export const currentUrlResolver = (data) => composeCurrentUrl(linkResolver(data));

export function getLinkedInShareURL(link) {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${link}`;
}
export function getTwitterShareURL(link, text) {
  return `https://twitter.com/share?text=${encodeURIComponent(text)}&url=${link}`;
}
export function getFacebookShareURL(link, text) {
  return `http://www.facebook.com/sharer.php?u=${link}&p[title]=${encodeURIComponent(text)}`;
}
